import { FilteredCreditApplication } from '@src/api/types/FilteredCreditApplication'
import { ManageCoappButton } from '@src/components'
import { trackEvent } from '@src/services/trackingEvents'
import { ETrackedEvents } from '@src/types/tracking'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DeclinedCancelAppButton from './DeclinedCancelAppButton'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    trackEvent(ETrackedEvents.QualifDeclined, creditApp)
  }, [creditApp])

  return (
    <main className="form-section" style={{ textAlign: 'center' }}>
      <h4 className="subtitle">{t('common.financeApplication')}</h4>
      <p>
        {t(`finalDecision.refusedHasCoApplicant.${creditApp.coapplicant !== null}`, {
          forStep: t('common.qualified'),
        })}
      </p>
      <div className="btn-group mobile-reversed space-between" style={{ marginTop: '16px' }}>
        <DeclinedCancelAppButton creditApp={creditApp} cancelEventName={ETrackedEvents.WithdrewAfterQualif} />
        <ManageCoappButton creditAppId={creditApp.id} useChangeLabel={creditApp.coapplicant !== null} />
      </div>
    </main>
  )
}

export default DeclinedDecisionForm
